// import Vue from 'vue'
import server from '../../api/server'
import StoreClasses from './StoreClasses'

// import moment from 'moment'
// class ItemSet {
//   constructor () {
//     this.items = []
//     this.loadedPages = 0
//     this.total = 0
//     this.page = 0
//     this.filter = {
//       search: '',
//       tagIds: [],
//       isShowOther: false
//     }
//     this.filterChanged = true
//   }
//   setItems (data, cxt) {
//     if (JSON.stringify(this.filter) === JSON.stringify(cxt)) {
//       this.items = this.loadedPages === 0 || data.first ? data.content : this.items.concat(data.content)
//       this.loadedPages = data.totalPages > data.number ? data.number + 1 : data.totalPages
//       this.total = data.totalElements
//     }
//   }
//   setFilter (cxt) {
//     if (JSON.stringify(this.filter) !== JSON.stringify(cxt)) {
//       this.loadedPages = 0
//       this.page = 0
//       this.filter = cxt
//       this.filterChanged = true
//     }
//   }
//   isChanged () {
//     return this.filterChanged
//   }
//   clearChanged () {
//     this.filterChanged = false
//   }
//   nextPage () {
//     if (this.page !== this.loadedPages) {
//       if (this.items.length < this.total) {
//         this.page = this.loadedPages
//         this.filterChanged = true
//       }
//     }
//   }
// }

const state = {
  constant: {
    ACTIVE_SCOPE: 'ACTIVE_SCOPE',
    ALL_SCOPE: 'ALL_SCOPE'
  },
  tags: [],
  peopleSet: new StoreClasses.ItemSet(item => item.id)
}

// getters
const getters = {
  getPeopleFilterContext: state => state.peopleSet.filter,
  getPeople: state => state.peopleSet.items,
  getPeopleTotal: state => state.peopleSet.total,
  getPeopleSet: state => state.peopleSet
}

// actions
const actions = {
  fetchPeople ({commit, state, getters}, force) {
    if (getters.getProfileLoaded && (getters.getProfileHaveClient !== true)) {
      return
    }
    if (!force && !state.peopleSet.isChanged()) {
      return
    }
    var page = force ? 0 : state.peopleSet.page
    var fxt = Object.assign({}, state.peopleSet.getFilter())
    commit('startPeopleFileSet')
    server.apiGetParams(
      '/api/me/people/individuals',
      {
        size: 100,
        page: page,
        request: {
          search: fxt.search
        }
      },
      (data) => {
        commit('setPeopleFileSet', {data: data, cxt: fxt})
        commit('setSuccessStatus')
      },
      (e) => {
        commit('stopPeopleFileSet')
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении контактов клиента  '})
      }
    )
  },
  findPeople ({commit, state, getters}, search) {
    return new Promise((resolve, reject) => {
      server.apiGetParams(
        '/api/me/people/individuals',
        {
          size: 5,
          page: 0,
          request: {
            search: search
          }
        },
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении при получении контактов клиента '})
          reject(e)
        })
    })
  },
  getPeopleIndividual ({commit, state, rootState}, id) {
    return new Promise((resolve, reject) => {
      server.apiGet(
        '/api/me/people/individuals/' + id,
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении контакта'})
        }
      )
    })
  },
  getPeopleIndividualDoc ({commit, state, rootState}, id) {
    return new Promise((resolve, reject) => {
      server.apiGet(
        '/api/me/people/individualDocs/' + id,
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении документа контакта'})
        }
      )
    })
  },
  getPeopleIndividualPassport ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      let innflsStr = request && request.innfls ? request.innfls.join(',') : null
      let companyRefCode = request && request.companyRefCode ? request.companyRefCode : null
      server.apiGetParams(
        '/api/me/people/individualPassports',
        {
          innfls: innflsStr,
          companyRefCode: companyRefCode
        },
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении документа контакта'})
        }
      )
    })
  },
  getPeopleIndividualContact ({commit, state, rootState}, id) {
    return new Promise((resolve, reject) => {
      server.apiGet(
        '/api/me/people/individualContacts/' + id,
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении документа контакта'})
        }
      )
    })
  },
  updatePeopleIndividual ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      server.apiPost(
        '/api/me/people/individuals/',
        request,
        (data) => {
          this.dispatch('fetchPeople', true)
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при добавлении/изменении  контакта '})
        }
      )
    })
  },
  updatePeopleIndividuals ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      server.apiPost(
        '/api/me/people/command-individuals-updates',
        {dtos: request.dtos},
        (data) => {
          this.dispatch('fetchPeople', true)
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при добавлении/изменении контакта '})
        }
      )
    })
  },
  deletePeopleIndividuals ({commit, state, rootState}, request) {
    // console.log('deletePeopleIndividuals', request)
    server.apiPost(
      '/api/me/people/command-individuals-deletes',
      {ids: request.ids},
      (data) => {
        this.dispatch('fetchPeople', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при удалении записей о контактах '})
      }
    )
  },
  updatePeopleContact ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      server.apiPost(
        '/api/me/people/command-contact-updates',
        {dto: request},
        (data) => {
          this.dispatch('fetchPeople', true)
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при добавлении контакта в избранное '})
        }
      )
    })
  },
  deletePeopleContact ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      server.apiPost(
        '/api/me/people/command-contact-deletes',
        {ids: request.ids},
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при удалении записей о контактах '})
        }
      )
    })
  },
  updatePeopleDoc ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      var item = Object.assign({}, request)
      item.model = JSON.stringify(item.model)
      // console.log('updatePeopleDoc', item)
      server.apiPost(
        '/api/me/people/command-doc-updates',
        {dto: item},
        (data) => {
          this.dispatch('fetchPeople', true)
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при добавлении контакта в избранное '})
        }
      )
    })
  },
  deletePeopleDocs ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      server.apiPost(
        '/api/me/people/command-doc-deletes',
        {ids: request.ids},
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при удалении записей о контактах '})
        }
      )
    })
  }
}
// mutations
const mutations = {
  setPeopleFilterContext (state, cxt) {
    state.peopleSet.setFilter(cxt)
  },
  clearPeopleFilterContextChanged (state) {
    state.peopleSet.clearChanged()
  },
  nextPeople (state) {
    state.peopleSet.nextPage()
  },
  setPeople (state, {data, cxt}) {
    state.peopleSet.setItems(data, cxt)
  },
  startPeopleFileSet (state) {
    state.peopleSet.clearChanged()
    state.peopleSet.start()
  },
  stopPeopleFileSet (state) {
    state.peopleSet.stop()
  },
  nextPeopleFileSet (state) {
    state.peopleSet.nextPage()
  },
  setPeopleFileSet (state, {data, cxt}) {
    state.peopleSet.setItems(data, cxt)
    state.peopleSet.stop()
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/people.js